import { Fragment } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

import style from "./style.module.scss";
import type { StepperProps } from "../../types";

function Stepper({ className, steps, onNavigate = () => {} }: StepperProps) {
  return (
    <div className={classnames(style.breadcrumb, className)}>
      {steps.map((step, index) => {
        const stepClassName = classnames(style.step, {
          [style.isActive]: step.isActive,
          [style.isDisabled]: step.isDisabled,
        });

        const isLink = step.link && !step.isDisabled;
        const content = (
          <Fragment>
            <span className={style.stepIndex}>{index + 1}</span>
            <span className={style.stepLabel}>{step.label}</span>
          </Fragment>
        );

        if (isLink) {
          return (
            <Link key={step.id} className={stepClassName} to={step.link!}>
              {content}
            </Link>
          );
        }

        return (
          <a
            key={step.id}
            className={stepClassName}
            onClick={(event) => {
              event.preventDefault();
              onNavigate(step.id);
            }}
          >
            {content}
          </a>
        );
      })}
    </div>
  );
}

export default Stepper;
